import {SortSubsidiaryPageModel} from '../Model'
import {SubsidiaryPageModel} from '../Model/SubsidiaryPageModel'

export const actionTypes = {
  // get
  GET_ALL_SUBSIDIARY_PAGE_START: 'GET_ALL_SUBSIDIARY_PAGE_START',
  GET_ALL_SUBSIDIARY_PAGE_SUCCESS: 'GET_ALL_SUBSIDIARY_PAGE_SUCCESS',
  GET_ALL_SUBSIDIARY_PAGE_FINISH: 'GET_ALL_SUBSIDIARY_PAGE_FINISH',

  // extended hours
  GET_SUBSIDIARY_PAGE_START: 'GET_SUBSIDIARY_PAGE_START',
  GET_SUBSIDIARY_PAGE_SUCCESS: 'GET_SUBSIDIARY_PAGE_SUCCESS',
  GET_SUBSIDIARY_PAGE_FINISH: 'GET_SUBSIDIARY_PAGE_FINISH',

  // add branch
  ADD_SUBSIDIARY_PAGE_START: 'ADD_SUBSIDIARY_PAGE_START',
  ADD_SUBSIDIARY_PAGE_SUCCESS: 'ADD_SUBSIDIARY_PAGE_SUCCESS',
  ADD_SUBSIDIARY_PAGE_FINISH: 'ADD_SUBSIDIARY_PAGE_FINISH',
  RESET_SUBSIDIARY_PAGE: 'RESET_SUBSIDIARY_PAGE',

  // update SUBSIDIARY_PAGE
  UPDATE_SUBSIDIARY_PAGE_START: 'UPDATE_SUBSIDIARY_PAGE_START',
  UPDATE_SUBSIDIARY_PAGE_SUCCESS: 'UPDATE_SUBSIDIARY_PAGE_SUCCESS',
  UPDATE_SUBSIDIARY_PAGE_FINISH: 'UPDATE_SUBSIDIARY_PAGE_FINISH',

  // delete SUBSIDIARY_PAGE
  DELETE_SUBSIDIARY_PAGE_START: 'DELETE_SUBSIDIARY_PAGE_START',
  DELETE_SUBSIDIARY_PAGE_SUCCESS: 'DELETE_SUBSIDIARY_PAGE_SUCCESS',
  DELETE_SUBSIDIARY_PAGE_FINISH: 'DELETE_SUBSIDIARY_PAGE_FINISH',

  // Enable SUBSIDIARY_PAGE
  ENABLE_SUBSIDIARY_PAGE_REQUEST: 'ENABLE_SUBSIDIARY_PAGE_REQUEST',
  ENABLE_SUBSIDIARY_PAGE_SUCCESS: 'ENABLE_SUBSIDIARY_PAGE_SUCCESS',
  ENABLE_SUBSIDIARY_PAGE_FINISH: 'ENABLE_SUBSIDIARY_PAGE_FINISH',

  // Disable SUBSIDIARY_PAGE
  DISABLE_SUBSIDIARY_PAGE_REQUEST: 'DISABLE_SUBSIDIARY_PAGE_REQUEST',
  DISABLE_SUBSIDIARY_PAGE_SUCCESS: 'DISABLE_SUBSIDIARY_PAGE_SUCCESS',
  DISABLE_SUBSIDIARY_PAGE_FINISH: 'DISABLE_SUBSIDIARY_PAGE_FINISH',

  // Enable SUBSIDIARY_PAGE
  SINGLE_ENABLE_SUBSIDIARY_PAGE_REQUEST: 'SINGLE_ENABLE_SUBSIDIARY_PAGE_REQUEST',
  SINGLE_ENABLE_SUBSIDIARY_PAGE_SUCCESS: 'SINGLE_ENABLE_SUBSIDIARY_PAGE_SUCCESS',
  SINGLE_ENABLE_SUBSIDIARY_PAGE_FINISH: 'SINGLE_ENABLE_SUBSIDIARY_PAGE_FINISH',

  // Disable SUBSIDIARY_PAGE
  SINGLE_DISABLE_SUBSIDIARY_PAGE_REQUEST: 'SINGLE_DISABLE_SUBSIDIARY_PAGE_REQUEST',
  SINGLE_DISABLE_SUBSIDIARY_PAGE_SUCCESS: 'SINGLE_DISABLE_SUBSIDIARY_PAGE_SUCCESS',
  SINGLE_DISABLE_SUBSIDIARY_PAGE_FINISH: 'SINGLE_DISABLE_SUBSIDIARY_PAGE_FINISH',

  // sort
  SORT_SUBSIDIARY_PAGE_START: 'SORT_SUBSIDIARY_PAGE_START',
  SORT_SUBSIDIARY_PAGE_SUCCESS: 'SORT_SUBSIDIARY_PAGE_SUCCESS',
  SORT_SUBSIDIARY_PAGE_FINISH: 'SORT_SUBSIDIARY_PAGE_FINISH',
  SORT_SUBSIDIARY_PAGE_RESET: 'SORT_SUBSIDIARY_PAGE_RESET',
}
